import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    // Check localStorage or system preference
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const saved = localStorage.getItem("chatIQ-theme");
        if (saved) return saved === "dark";
        return false; // ☀️ Default to Light Mode globally
    });

    useEffect(() => {
        localStorage.setItem("chatIQ-theme", isDarkMode ? "dark" : "light");

        // Apply class to HTML tag for Tailwind dark mode (optional, but good practice)
        if (isDarkMode) {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [isDarkMode]);

    const toggleTheme = () => setIsDarkMode((prev) => !prev);

    // Define global style objects or classes accessed via context if needed, 
    // or just expose the boolean.
    const theme = {
        isDarkMode,
        toggleTheme,
        // Pre-defined classes for consistency (optional consumption)
        bg: isDarkMode ? "bg-[#0b141a]" : "bg-[#f0f2f5]",
        text: isDarkMode ? "text-white" : "text-gray-900",
    };

    return (
        <ThemeContext.Provider value={theme}>
            {children}
        </ThemeContext.Provider>
    );
};
